import styled from "styled-components";
import Link from "next/link";
import { theme } from "@/styles/theme";
import { media } from "@/styles/media";
import { useTranslation } from "react-i18next";

export default function InbodyUsedItem({ ...props }: { title: string; bgPath: string; href: string }) {
  const { t } = useTranslation();

  return (
    <UsedWrapper href={props.href} $path={props.bgPath}>
      <Title>{t(props.title)}</Title>
      <Arrow src="/icons/arrow-right-solid.svg" />
    </UsedWrapper>
  );
}

const UsedWrapper = styled(Link)<{ $path: string }>`
  position: relative;
  width: 351px;
  height: 298px;
  border-radius: 10px;
  overflow: hidden;

  // bg
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: url(${({ $path }) => $path}) center / cover no-repeat;
    transition: transform 0.3s ease-out;
    z-index: 0;
    will-change: transform;
  }

  // dim
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: rgba(1, 1, 1, 0.4);
    transition: background-color 0.3s ease-out;
    z-index: 1;
    border-radius: 10px;
  }

  &:hover::after {
    transform: scale(1.1);
  }
  &:hover::before {
    background-color: rgba(1, 1, 1, 0);
  }

  > * {
    position: relative;
    z-index: 2;
  }
  ${media.tablet`
        width: 100%;
      `}
`;
const Title = styled.p`
  position: absolute;
  top: 2rem;
  left: 2.5rem;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  display: block;
  font-size: 1.6rem;
  text-shadow: ${theme.colors.text.grayLight} 1px 1px 3px;
  color: ${theme.colors.text.white};
`;
const Arrow = styled.img`
  position: absolute;
  bottom: 2rem;
  right: 2.5rem;
  width: 40px;
  transform: rotate(-45deg);
`;
